import { HttpError } from './httpError';
const JSON_CONTENT_TYPE_PATTERN = /[/+]json\b/i;
const RESPONSE_WITHOUT_BODY_STATUS_CODES = new Set([204, 205, 304]);

const getRequestUrl = (input: RequestInfo | URL, response: Response) => {
  if (response.url) {
    return response.url;
  }

  if (typeof input === 'string') {
    return input;
  }

  if (input instanceof URL) {
    return input.toString();
  }

  return input.url;
};

export async function getResponseData<T>(response: Response): Promise<T | undefined> {
  if (RESPONSE_WITHOUT_BODY_STATUS_CODES.has(response.status)) {
    return undefined;
  }

  const body = await response.text();

  if (!body) {
    return undefined;
  }

  if (JSON_CONTENT_TYPE_PATTERN.test(response.headers.get('content-type') ?? '')) {
    return JSON.parse(body) as T;
  }

  return body as T;
}

export async function fetchJson<T>(input: RequestInfo | URL, init?: RequestInit): Promise<T> {
  const response = await fetch(input, init);
  const data = await getResponseData<T>(response);

  if (!response.ok) {
    throw HttpError.fromResponse(response, {
      data,
      request: {
        headers: init?.headers ? Object.fromEntries(new Headers(init.headers).entries()) : undefined,
        method: init?.method ?? 'GET',
        url: getRequestUrl(input, response),
      },
    });
  }

  return data as T;
}
